export const contact = {
  title: 'Contactez-nous',
  subtitle: 'Nous sommes là pour vous aider. N\'hésitez pas à nous contacter pour toute question.',
  form: {
    name: 'Nom',
    email: 'Email',
    subject: 'Sujet',
    message: 'Message',
    submit: 'Envoyer'
  }
}; 